import { useCallback } from 'react';

export const useEmitMessage = (
  type: EmitMessageTypeType = 'toaster',
) => {

  const emitMessage = useCallback((
    message: MessageType,
    behavior: EmitMessageBehaviorType = 'fade'
  ) => {
    if (message) {
      window.parent.postMessage({ 
        action: 'message',
        message,
        behavior,
        type 
      }, '*'); 
    }
  }, [type]);

  return emitMessage;
};

// types

type EmitMessageBehaviorType = 'keep' | 'fade'
type EmitMessageTypeType = 'toaster' | 'modal'

export type MessageType = 
  | 'app-error' 
  | 'app-updating' 
  | 'app-complete' 
  | 'app-not-get-token' 
  | 'app-loading-addline'
  | 'app-success-addline'
  | 'app-ban-addline'
  | 'app-ban-max-quantity'
  | 'app-ban-increaseline'
  | 'app-loading-updateline'
  | 'app-success-updateline'
  | 'app-loading-removeline'
  | 'app-success-removeline'
  | 'app-failed-any'
  | 'app-update-shipping' 
  | 'app-modify-shipping' 
  | 'app-updating-address' 
  | 'app-modify-address' 
  | 'app-canceling-contract' 
  | 'app-updating-payment' 
  | 'app-loading-subscription' 
  | 'app-updating-subscription' 
  | 'app-transfer-cartitem' 
  | 'app-updating-deliverydate' 
  | 'app-modify-deliverydate' 
  | 'app-modify-skip' 
  | 'app-modify-interval' 
  | 'app-soldout-variant'
  | 'app-ban-empty' 
  | '';
